// src/utils/humanizeAreaKey.js
// Converts camelCase area keys (e.g. 'userSafety', 'securityAndMisuse') into
// human-readable labels ('User Safety', 'Security & Misuse'). Used in the
// review canvas + report views where the raw key would otherwise appear.

const SPECIAL = {
  And: '&',
  // Add more abbreviation overrides here if needed
};

export function humanizeAreaKey(key) {
  if (!key || typeof key !== 'string') return key;

  // Insert space before each uppercase letter, then split on spaces
  const parts = key
    .replace(/([A-Z])/g, ' $1')
    .trim()
    .split(/\s+/);

  return parts
    .map((p) => {
      const cap = p.charAt(0).toUpperCase() + p.slice(1).toLowerCase();
      return SPECIAL[cap] || cap;
    })
    .join(' ');
}

export default humanizeAreaKey;
